import styled from 'styled-components';
import Image from 'next/image';
import { Breakpoints } from '../../../styled/constants';

export const AgencyInfoBlockWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.background.primary};
  margin-bottom: 20px;
  border-radius: 0 0 24px 24px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 30px 40px;
    border-radius: 24px;
    margin-bottom: 30px;
  }
`;

export const TopCoverImg = styled(Image)`
  width: 100%;
  height: 100px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    height: 341px;
  }
`;

export const AgencyInfoContent = styled.div`
  padding: 20px 15px;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 20px 40px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin-top: 28px;
  }
`;
